
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"57","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"27","cy":"29","r":"27","fill":"#00E074"}}),_c('path',{attrs:{"d":"M27.308 14.564c2.635 0 4.75.722 6.346 2.166 1.622 1.419 2.432 3.382 2.432 5.89 0 2.483-.798 4.383-2.394 5.7-1.596 1.292-3.711 1.938-6.346 1.938l-.152 2.926H22.52l-.19-6.46h1.71c2.204 0 3.902-.291 5.092-.874 1.191-.583 1.786-1.647 1.786-3.192 0-1.115-.329-2.001-.988-2.66-.633-.659-1.507-.988-2.622-.988-1.165 0-2.077.317-2.736.95-.633.633-.95 1.507-.95 2.622h-5.016c-.025-1.545.304-2.926.988-4.142.684-1.216 1.685-2.166 3.002-2.85 1.343-.684 2.914-1.026 4.712-1.026zm-2.47 27.702c-.962 0-1.76-.291-2.394-.874-.608-.608-.912-1.355-.912-2.242s.304-1.621.912-2.204c.634-.608 1.432-.912 2.394-.912.938 0 1.71.304 2.318.912.608.583.912 1.317.912 2.204 0 .887-.304 1.634-.912 2.242-.608.583-1.38.874-2.318.874z","fill":"#141518"}})])
          )
        }
      }
    